import { render, staticRenderFns } from "./NewsCenter.vue?vue&type=template&id=3f01aeb6&scoped=true&"
import script from "./NewsCenter.vue?vue&type=script&lang=js&"
export * from "./NewsCenter.vue?vue&type=script&lang=js&"
import style0 from "./NewsCenter.vue?vue&type=style&index=0&id=3f01aeb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f01aeb6",
  null
  
)

export default component.exports